import { render, staticRenderFns } from "./VasionEllipsisMenu.vue?vue&type=template&id=5a678961&scoped=true"
import script from "./VasionEllipsisMenu.vue?vue&type=script&lang=js"
export * from "./VasionEllipsisMenu.vue?vue&type=script&lang=js"
import style0 from "./VasionEllipsisMenu.vue?vue&type=style&index=0&id=5a678961&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a678961",
  null
  
)

export default component.exports